import accountSignin from './account/signin';
import accountSignup from './account/signup';
import accountCheckEmail from './account/checkEmail';
import accountSendPasswordResetLink from './account/sendPasswordResetLink';
import accountGet from './account/get';
import accountSave from './account/save';
import formSave from './form/save';
import formGet from './form/get';
import listCreate from './list/create';
import listDelete from './list/delete';
import listGet from './list/get';
import listGetAll from './list/getAll';
import listUpdate from './list/update';
import tableSearch from './table/search';
import catalogGetItems from './catalog/getItems';
import todoCreate from './todo/create';
import todoDelete from './todo/delete';
import todoGetAll from './todo/getAll';
import todoUpdate from './todo/update';

export default {
    get: function (url) {
        console.log('GET: ' + url);

        switch (url) {
            case '/api/account/':
                return accountGet.get(url);
            case '/api/form/':
                return formGet.get(url);
            case '/api/list/':
                return listGetAll.get(url);
            case '/api/todo/':
                return todoGetAll.get(url);
            default:
                if (url.indexOf('/api/account/checkEmail') === 0) {
                    return accountCheckEmail.get(url);
                }
                else if (url.indexOf('/api/list/') === 0) {
                    return listGet.get(url);
                }
                else if (url.indexOf('/api/catalog/getItems') === 0) {
                    return catalogGetItems.get(url);
                }
        }

        return null;
    },
    post: function (url, data) {
        console.log('POST: ' + url);
        console.log(data);

        switch (url) {
            case '/api/error/log':
                return new Promise(function (resolve, reject) {
                    resolve({ body: {} });
                });
            case '/api/account/signin':
                return accountSignin.post(url, data);
            case '/api/account/signup':
                return accountSignup.post(url, data);
            case '/api/account/sendPasswordResetLink':
                return accountSendPasswordResetLink.post(url, data);
            case '/api/table/search':
                return tableSearch.post(url, data);
            case '/api/list/':
                return listCreate.post(url, data);
            case '/api/todo/':
                return todoCreate.post(url, data);
        }

        return null;
    },
    put: function (url, data) {
        console.log('PUT: ' + url);
        console.log(data);

        if (url.indexOf('/api/list/') === 0) {
            return listUpdate.put(url, data);
        }
        else if (url.indexOf('/api/todo/') === 0) {
            return todoUpdate.put(url, data);
        }
        else {
            switch (url) {
                case '/api/account/':
                    return accountSave.put(url, data);
                case '/api/form/':
                    return formSave.put(url, data);
            }
        }
        return null;
    },
    delete: function (url) {
        console.log('DELETE: ' + url);
        if (url.indexOf('/api/list/') === 0) {
            return listDelete.delete(url);
        }
        else if (url.indexOf('/api/todo/') === 0) {
            return todoDelete.delete(url);
        }
        return null;
    }
};



// WEBPACK FOOTER //
// ./test/data/server.js